import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";
import { RequirePermission } from "@/app/guards";
import { SettingsPage } from "@/nav/SettingsPage";

const settingsScreens = {
  "trackers": page(() => import("@/screens/vehicles/Trackers")),
  "api-keys": page(() => import("@/screens/vehicles/ApiKeys")),
  "audit": page(() => import("@/screens/vehicles/AuditLog")),
};

export const fleetRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission="tracker.view" title="No fleet access" />,
    children: [
      { id: "fleet.dashboard", path: "/vehicles", element: page(() => import("@/screens/vehicles/Dashboard")) },
      { id: "fleet.live", path: "/vehicles/live", element: page(() => import("@/screens/vehicles/LiveMap")) },
      { id: "fleet.list", path: "/vehicles/list", element: page(() => import("@/screens/vehicles/Vehicles")) },
      { id: "fleet.trips", path: "/vehicles/trips", element: page(() => import("@/screens/vehicles/Trips")) },
      { id: "fleet.trip", path: "/vehicles/trips/:id", element: page(() => import("@/screens/vehicles/TripReplay")) },
      { id: "fleet.drivers", path: "/vehicles/drivers", element: page(() => import("@/screens/vehicles/Drivers")) },
      { id: "fleet.scorecards", path: "/vehicles/scorecards", element: page(() => import("@/screens/vehicles/Scorecards")) },
      { id: "fleet.geofences", path: "/vehicles/geofences", element: page(() => import("@/screens/vehicles/Geofences")) },
      { id: "fleet.maintenance", path: "/vehicles/maintenance", element: page(() => import("@/screens/vehicles/Maintenance")) },
      { id: "fleet.fuel", path: "/vehicles/fuel", element: page(() => import("@/screens/vehicles/Fuel")) },
      { id: "fleet.documents", path: "/vehicles/documents", element: page(() => import("@/screens/vehicles/Documents")) },
      { id: "fleet.reports", path: "/vehicles/reports", element: page(() => import("@/screens/vehicles/Reports")) },
      { id: "fleet.cost", path: "/vehicles/reports/cost", element: page(() => import("@/screens/vehicles/CostReport")) },
      { id: "fleet.settings", path: "/vehicles/settings/:tab?", element: <SettingsPage itemId="fleet-settings" screens={settingsScreens} /> },
    ],
  },
  // Route planning lived in the hub app without the tracker.view gate; unchanged.
  { id: "fleet.planner", path: "/routes", element: page(() => import("@/screens/Routes")) },
  { id: "fleet.my-routes", path: "/my-routes", element: page(() => import("@/screens/MyRoutes")) },
];
